import { render } from "./UserPledges.vue?vue&type=template&id=6c5410b4"
import script from "./UserPledges.vue?vue&type=script&lang=js"
export * from "./UserPledges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__